/* 🤖 this file was generated by script */
export const wiconChevronSelectorVertical = {
  name: 'chevron_selector_vertical',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 15l5 5 5-5M7 9l5-5 5 5"/></svg>`,
};
